/**
 * MongoDB Realm App State
 *
 * DEPRECATED: MongoDB Atlas App Services (Realm) has reached End of Life (EOL).
 * The Realm.App is no longer initialized to prevent 410 Gone errors.
 *
 * Authentication and data operations have been migrated to:
 * - Nexus Apollo Client (`@/apollo/nexusClient.ts`) for GraphQL
 * - Secure Storage (`@/services/secureStorage`) for token management
 *
 * This module is kept as a stub for backwards compatibility with code that
 * still references the realmApp store module.
 *
 * @deprecated Since MongoDB Realm EOL - January 2026
 */

// Stub that provides the expected interface without making network calls
const state: { app: any } = {
  app: {
    // Stub properties to prevent runtime errors in legacy code
    currentUser: null,
    logIn: async () => {
      console.warn('[DEPRECATED] MongoDB Realm has reached EOL. Use Nexus authentication instead.');
      return null;
    },
    emailPasswordAuth: {
      registerUser: async () => {
        console.warn('[DEPRECATED] MongoDB Realm has reached EOL.');
      }
    }
  }
};
export default state;
